// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SC6Zy","content":"styles_content__1p5Z4","tableWrap":"styles_tableWrap__369uV"};